import { render, staticRenderFns } from "./ProfileViewStudentPlanCard.vue?vue&type=template&id=9cde158a&"
import script from "./ProfileViewStudentPlanCard.vue?vue&type=script&lang=js&"
export * from "./ProfileViewStudentPlanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports